import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ECharts from 'vue-echarts';
import echarts from 'echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/bar';
import CODE from './configs/error-code';
import MSG from './configs/error-message';
import ListStatus from './configs/list-status';
import FunctionCode from './configs/function-list';
import ErrorPlugin from './plugins/error-plugin';
import PopupPlugin from './plugins/popup-plugin';
import CheckTypePlugin from './plugins/check-type-plugin';
import HttpPlugin from './plugins/http-plugin';
import App from './App.vue';
import router from './router';
import store from './store';
import API from './api';
import './assets/script/busitrans';
import timeFormatter from './utils/format-time';
import numberFormatter from './utils/format-currency';
import trimProps from './utils/trim-props';
import blankValue from './utils/blank-value';
import encrypt from './utils/encrypt';
import ValidatePlugin from './plugins/validate-plugin';
import PickerOptionsPlugin from './plugins/picker-options-plugin';
import * as custom from './utils/filters';

import Print from 'vue-print-nb';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

Vue.use(VueQuillEditor);

Vue.use(Print);


Vue.prototype.$CODE = CODE;
Vue.prototype.$API = API;
Vue.prototype.$MSG = MSG;
Vue.prototype.$LS = ListStatus;
Vue.prototype.$FC = FunctionCode;
Vue.prototype.$echarts = echarts;

Vue.component('v-chart', ECharts);
Vue.use(ElementUI);
Vue.use(ErrorPlugin); // 统一错误处理
Vue.use(PopupPlugin); // 封装 $alert，$confirm
Vue.use(CheckTypePlugin); // 类型判断
Vue.use(HttpPlugin); // 封装 get post delete put 请求
Vue.use(ValidatePlugin);
Vue.use(PickerOptionsPlugin); // 为 element date picker 生成 disabled 日期
Vue.config.productionTip = false;
Object.keys(timeFormatter).forEach((key) => {
  Vue.prototype[key] = timeFormatter[key];
  Vue.filter(key, timeFormatter[key]);
});
Object.keys(numberFormatter).forEach((key) => {
  Vue.prototype[key] = numberFormatter[key];
  Vue.filter(key, numberFormatter[key]);
});
Object.keys(trimProps).forEach((key) => {
  Vue.prototype[key] = trimProps[key];
});
Object.keys(blankValue).forEach((key) => {
  Vue.filter(key, blankValue[key]);
});
Object.keys(encrypt).forEach((key) => {
  Vue.prototype[key] = encrypt[key];
  Vue.filter(key, encrypt[key]);
});
Object.keys(custom).forEach((key) => {
  Vue.filter(key, custom[key]);
});

router.beforeEach((to, from, next) => {
  // const reg = /^\/login\/*/;
  // if (to.path === '/login') {
  //   sessionStorage.removeItem('sessionData');
  //   sessionStorage.clear();
  // }
  // const userLogin = JSON.parse(sessionStorage.getItem('sessionData'));
  // if (!userLogin && !reg.exec(to.path)) {
  //   next({ path: '/login' });
  //   Promise.resolve()
  //     .then(() => store.commit('resetPageTab'))
  //     .catch(e => console.log(e));
  // } else {
  //   next();
  // }
  next();
});
router.onError(console.log);
const componentsContext = require.context('./components', false, /\.vue$/);
componentsContext.keys().forEach((component) => {
  // 获取文件中的 default 模块
  const componentConfig = componentsContext(component).default;
  Vue.component(componentConfig.name, componentConfig);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
